// Global navigation
export const SIGN_OUT = 'Logout of Moderne';
export const SEARCH_BAR_PLACEHOLDER = 'Search recipes';

// Recipe Configuration
export const REQUIRED_FIELD = 'Required';

//  Load External Recipes
export const NO_EXTERNAL_RECIPES_FOUND =
  'Looks like we were unable to find any recipes for that artifact.';

// Recipe Form
export const REQUIRED_FIELD_ERROR = 'This field is required.';

export type KnownSignInErrorKey = keyof typeof KNOWN_SIGN_IN_ERRORS;

export const KNOWN_SIGN_IN_ERRORS = {
  sessionExpired: 'Your session expired. Please sign in again.',
  invalidToken: 'Invalid token'
};

export const GENERIC_SIGN_IN_ERROR = 'An error occurred. Please sign in again.';

export const MODDY_DISCLAIMER_TEXT = `Notice: This AI agent combines deterministic tools with AI-generated suggestions to analyze and transform codebases. While deterministic recipes ensure predictable, repeatable changes,  AI-generated outputs may vary and should be independently reviewed.`;

export const PLATFORM_UPDATE_IN_PROGRESS = 'Platform update in progress';

export const PROFILING_SETTINGS_DESCRIPTION =
  'Capture platform-wide performance diagnostics; all users will see a status indicator and may notice slower response times while profiling is on.';

export const OPTION_DEFAULTS_HINT = 'Leave blank to use the default.';
export const OPTION_BLANK_USES_RECIPE_DEFAULT =
  '(Leaving blank will use the default behavior of the recipe)';
